import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const {
    borderWidth1,
    borderWidth2,
    borderRadius3,
    colorBorderInteractive,
    colorBorderInputFocus,
    colorText,
    space025,
    space1,
    space3,
    space4,
  } = theme();

  return StyleSheet.create({
    text: {
      color: colorText,
      flex: 1,
      marginLeft: space4,
    },
    wrapper: {
      alignItems: "center",
      flex: 1,
      flexDirection: "row",
      marginVertical: space3,
    },
    wrapperLookiero: {
      borderColor: colorBorderInteractive,
      borderRadius: borderRadius3,
      borderWidth: borderWidth1,
      marginVertical: space1,
      padding: space4,
    },
    wrapperLookieroChecked: {
      borderColor: colorBorderInputFocus,
      borderWidth: borderWidth2,
      padding: space4 - space025,
    },
  });
};

export { style };
